import React from 'react';
import AppIcon from '../../../components/AppIcon';

const MetricsCard = ({ icon: iconName, title, value, trend, currency, onClick, isActive }) => {
  const formatValue = (val) => {
    return new Intl.NumberFormat('ar-EG')?.format(val);
  };

  const formatCurrency = (amount, curr) => {
    const formatted = new Intl.NumberFormat('ar-EG')?.format(amount);
    return `${formatted} ${curr}`;
  };

  return (
    <div 
      className={`bg-slate-800/50 rounded-md p-3 border transition-all duration-200 ${
        onClick ? 'cursor-pointer hover:bg-slate-800/70' : ''
      } ${
        isActive ? 'border-amber-500/60 bg-slate-800/60' : 'border-slate-700/50 hover:border-amber-500/40'
      }`}
      onClick={onClick}
      role={onClick ? 'button' : 'presentation'}
      tabIndex={onClick ? 0 : -1}
      onKeyDown={(e) => {
        if (onClick && (e?.key === 'Enter' || e?.key === ' ')) {
          e?.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <div className="p-1.5 rounded bg-amber-500/10 flex-shrink-0">
            <AppIcon name={iconName} size={16} color={isActive ? '#DAA520' : '#B8860B'} />
          </div>
          <p className="text-xs text-slate-400 font-medium truncate">{title}</p>
        </div>
        {trend && (
          <div className={`flex items-center gap-0.5 px-1.5 py-0.5 rounded text-xs font-medium flex-shrink-0 ${
            trend?.isPositive ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <AppIcon 
              name={trend?.isPositive ? 'TrendingUp' : 'TrendingDown'} 
              size={10} 
            />
            <span className="text-[10px]">{trend?.value}%</span>
          </div>
        )}
      </div>
      <p className="text-lg font-semibold text-foreground truncate" dir="ltr">
        {currency ? formatCurrency(value, currency) : formatValue(value)}
      </p>
    </div>
  );
};

export default MetricsCard;